export const useOpenInNewTab = () => {
  return (path: string) => window.open(path, '_blank');
};
